var _rect, _rect2, _rect3, _text, _text2, _text3, _path, _path2, _rect4, _rect5, _text4, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizonAcademy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 750,
    fill: "#173c5c"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 1060,
    height: 610,
    rx: 26,
    fill: "#f5f9fd"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 1060,
    height: 82,
    rx: 26,
    fill: "#1b74a8"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 122,
    fontFamily: "Arial",
    fontSize: 28,
    fontWeight: 700,
    fill: "#fff"
  }, "HORIZON ACADEMY")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 250,
    fontFamily: "Arial",
    fontSize: 62,
    fontWeight: 700,
    fill: "#173c5c"
  }, "Learn beyond limits.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 300,
    fontFamily: "Arial",
    fontSize: 23,
    fill: "#657d91"
  }, "A brighter path for curious minds.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M790 480V310l130-95 130 95v170Z",
    fill: "#f0c45c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M755 320 920 190l165 130",
    fill: "none",
    stroke: "#173c5c",
    strokeWidth: 24
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 865,
    y: 370,
    width: 110,
    height: 110,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 420,
    width: 270,
    height: 64,
    rx: 32,
    fill: "#ed704e"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 177,
    y: 460,
    fontFamily: "Arial",
    fontSize: 20,
    fontWeight: 700,
    fill: "#fff"
  }, "Explore learning")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 545,
    width: 210,
    height: 55,
    rx: 12,
    fill: "#dcebf5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 545,
    width: 210,
    height: 55,
    rx: 12,
    fill: "#dcebf5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizonAcademy);
export default __webpack_public_path__ + "static/media/horizon-academy.5d0a0a140030c1916c54550dc579c69d.svg";
export { ForwardRef as ReactComponent };